import { COMPANY_API } from 'apis';

const NS = '/captain-payment';

export const geMemberDivision = () => COMPANY_API.get(`${NS}/member/v1/division`);

export const getMemberAuth = () => COMPANY_API.get(`${NS}/member/v1/auth`);

export const getMemberGroup = () => COMPANY_API.get(`${NS}/member/v1/group`);

export const getMemberUserInfo = (userId) => COMPANY_API.get(`${NS}/member/v1/${userId}`);
export const getMemberRankPosition = (userId) => COMPANY_API.get(`${NS}/member/v1/rankposition`);
